import { Routes } from "@angular/router";
import { authGuard } from "./_guards/auth.guard";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { userResolver } from "./user/user.resolver";

export const routes: Routes = [
  { path: "", component: HomeComponent, data: { title: "Jeanz" } },
  { path: "login", component: LoginComponent },
  {
    path: "motoko",
    loadComponent: () => import("./motoko/motoko.component").then(m => m.MotokoComponent),
    canActivate: [authGuard],
  },
  {
    path: "shib",
    loadComponent: () => import("./shib/shib.component").then(m => m.ShibComponent),
    canActivate: [authGuard],
  },
  {
    path: "tracker",
    loadComponent: () => import("./tracker/tracker.component").then(m => m.TrackerComponent),
    canActivate: [authGuard],
  },
  {
    path: "overwatch",
    loadComponent: () => import("./overwatch/overwatch.component").then(m => m.OverwatchComponent),
    canActivate: [authGuard],
  },
  {
    path: "owntracks",
    loadComponent: () => import("./owntracks/owntracks.component").then(m => m.OwntracksComponent),
    canActivate: [authGuard],
  },
  {
    path: "Bluetooth",
    loadComponent: () => import("./bluetooth/bluetooth.component").then(m => m.BluetoothComponent),
    canActivate: [authGuard],
  },
  {
    path: "add-human",
    loadComponent: () => import("./humans/humans.component").then(m => m.HumansComponent),
    canActivate: [authGuard],
  },
  {
    path: "humans",
    loadComponent: () => import("./humans/humans.component").then(m => m.HumansComponent),
    canActivate: [authGuard],
  },
  {
    path: "house",
    loadComponent: () => import("./house/house.component").then(m => m.HouseComponent),
    canActivate: [authGuard],
  },
  {
    path: "office",
    loadComponent: () => import("./shed/shed.component").then(m => m.ShedComponent),
    canActivate: [authGuard],
  },
  {
    path: "eyes",
    loadComponent: () => import("./eyes/eyes.component").then(m => m.EyesComponent),
    canActivate: [authGuard],
  },
  {
    path: "deck",
    loadComponent: () => import("./deck/deck.component").then(m => m.DeckComponent),
    canActivate: [authGuard],
  },
  {
    path: "styles",
    loadComponent: () => import("./styles/styles.component").then(m => m.StylesComponent),
    canActivate: [authGuard],
  },
  {
    path: "user",
    loadComponent: () => import("./user/user.component").then(m => m.UserComponent),
    resolve: { data: userResolver },
    canActivate: [authGuard],
  },
  {
    path: "**",
    loadComponent: () => import("./page-not-found/page-not-found.component").then(m => m.PageNotFoundComponent),
  },
];
